const formats = [
  { icon: 'ri-group-line', title: 'Очные тренинги', desc: 'Живое взаимодействие в аудитории. Групповые упражнения, ролевые игры, разбор кейсов. Максимальное вовлечение и энергия группы.' },
  { icon: 'ri-computer-line', title: 'Онлайн-обучение', desc: 'Интерактивные вебинары и тренинги для распределённых команд. Экономия времени и бюджета без потери качества.' },
  { icon: 'ri-device-line', title: 'Смешанный формат', desc: 'Сочетание очных встреч и онлайн-инструментов. Гибкость охвата и глубина проработки навыков.' },
  { icon: 'ri-user-voice-line', title: 'Наставничество', desc: 'Передача опыта от старших сотрудников младшим. Индивидуальное развитие в процессе работы.' },
  { icon: 'ri-lightbulb-line', title: 'Коучинг', desc: 'Индивидуальная работа с сотрудником над конкретными целями. Раскрытие потенциала через вопросы и рефлексию.' },
  { icon: 'ri-gamepad-line', title: 'Бизнес-игры', desc: 'Имитация реальных бизнес-ситуаций. Развитие стратегического мышления, принятия решений и командной работы.' },
  { icon: 'ri-compass-3-line', title: 'Стратегические сессии', desc: 'Фасилитация встреч топ-команды. Разработка стратегии, постановка целей, синхронизация видения.' },
  { icon: 'ri-timer-line', title: 'Микрообучение', desc: 'Короткие форматы по 5-15 минут. Видео, чек-листы, карточки знаний. Поддержка навыков между основными программами.' },
  { icon: 'ri-slideshow-2-line', title: 'Электронные курсы', desc: 'Структурированные онлайн-программы с тестами и заданиями. Масштабирование обучения на всю компанию.' },
  { icon: 'ri-building-2-line', title: 'Корпоративная академия', desc: 'Полноценная внутренняя система обучения. Адаптация, развитие, оценка — всё в единой экосистеме.' },
];

export default function TrainingFormats() {
  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Какие форматы обучения бывают
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
          Современное обучение персонала — это не только тренинги. Вот 10 форматов, которые можно комбинировать для максимальной эффективности
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-5">
          {formats.map((f, i) => (
            <div key={i} className="bg-white rounded-2xl p-6 border border-gray-100 hover:border-teal-200 hover:shadow-md transition-all group">
              <div className="w-12 h-12 bg-teal-600 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                <i className={`${f.icon} text-xl text-white`}></i>
              </div>
              <h3 className="font-bold text-gray-900 mb-2 text-sm">{f.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}